var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-area"},[_c('topheader-component'),_c('middle-header-component'),_c('bottom-header-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }